import { NewDate, NewHour } from '@/Domain/News'
import { Recognition } from '@/Domain/Expediente'
import { DanosEvitablesDTO, DanosMadeirablesDTO, DanosNonMadeirablesDTO } from '.'

export class RecognitionDto {
  private _dataActa: NewDate | null
  private _horaActa: NewHour | null
  private _numSancionador: string | null
  private _observacions: string | null
  private _danos: boolean | null
  private _tipoDanos: string
  private _afeccionDanos: string
  private _danosEvitables: DanosEvitablesDTO | null
  private _danosMadeirables: DanosMadeirablesDTO | null
  private _danosNonMadeirables : DanosNonMadeirablesDTO | null

  static fromRecognition (recon: Recognition): RecognitionDto {
    const danoEvitable = recon.getDanosEvitables()
    let danoEvitableDto = null
    if (danoEvitable !== null) { danoEvitableDto = DanosEvitablesDTO.fromDanosEvitables(danoEvitable) }

    const danoMadeirable = recon.getDanosMadeirables()
    let danoMadeirableDto = null
    if (danoMadeirable !== null) { danoMadeirableDto = DanosMadeirablesDTO.fromDanosMadeirables(danoMadeirable) }

    const danoNonMadeirable = recon.getDanosNonMadeirables()
    let danoNonMadeirableDto = null
    if (danoNonMadeirable !== null) { danoNonMadeirableDto = DanosNonMadeirablesDTO.fromDanosNonMadeirables(danoNonMadeirable) }

    return new RecognitionDto(
      recon.dataActa ? new NewDate(recon.dataActa) : null,
      recon.horaActa ? new NewHour(recon.horaActa) : null,
      recon.numSancionador ? recon.numSancionador : null,
      recon.observacions ? recon.observacions : null,
      recon.danos ? recon.danos : null,
      recon.tipoDanos,
      recon.afeccionDanos,
      danoEvitableDto,
      danoMadeirableDto,
      danoNonMadeirableDto
    )
  }

  constructor (
    dataActa: NewDate | null,
    horaActa: NewHour | null,
    numSancionador: string | null,
    observacions: string | null,
    danos: boolean | null,
    tipoDanos: string,
    afeccionDanos: string,
    danosEvitables: DanosEvitablesDTO | null,
    danosMadeirables: DanosMadeirablesDTO | null,
    danosNonMadeirables: DanosNonMadeirablesDTO | null
  ) {
    this._dataActa = dataActa
    this._horaActa = horaActa
    this._numSancionador = numSancionador
    this._observacions = observacions
    this._danos = danos
    this._tipoDanos = tipoDanos
    this._afeccionDanos = afeccionDanos
    this._danosEvitables = danosEvitables
    this._danosMadeirables = danosMadeirables
    this._danosNonMadeirables = danosNonMadeirables
  }

  get dataActa (): string {
    if (this._dataActa !== null) {
      return this._dataActa.date()
    } else { return '' }
  }

  get horaActa (): string {
    if (this._horaActa !== null) {
      return this._horaActa.hour()
    } else { return '' }
  }

  get numSancionador (): string {
    if (this._numSancionador !== null) {
      return this._numSancionador
    } else { return '' }
  }

  get observacions (): string {
    if (this._observacions !== null) {
      return this._observacions
    } else { return '' }
  }

  get danos (): boolean {
    if (this._danos !== null) {
      return this._danos
    } else { return false }
  }

  get tipoDanos (): string {
    return this._tipoDanos || ''
  }

  get afeccionDanos (): string {
    return this._afeccionDanos || ''
  }

  get afeccionDanosStringified (): string {
    if (this._afeccionDanos === '1') {
      return 'Madeirables'
    }
    if (this._afeccionDanos === '2') {
      return 'Non madeirables'
    }
    if (this._afeccionDanos === '3') {
      return 'Madeirables e non madeirables'
    }
    return ''
  }

  get danosEvitables (): DanosEvitablesDTO | null {
    return this._danosEvitables
  }

  get tipoDanosStringified (): string {
    if (this._tipoDanos === '1') {
      return 'Evitables'
    }
    if (this._tipoDanos === '2') {
      return 'Inevitables'
    }
    if (this._tipoDanos === '3') {
      return 'Evitables e inevitables'
    }
    return ''
  }

  public setDanosEvitables (danos: DanosEvitablesDTO): void {
    this._danosEvitables = danos
  }

  get danosMadeirables (): DanosMadeirablesDTO | null {
    return this._danosMadeirables
  }

  public setDanosMadeirables (danosMadeirables: DanosMadeirablesDTO): void {
    this._danosMadeirables = danosMadeirables
  }

  get danosNonMadeirables (): DanosNonMadeirablesDTO | null {
    return this._danosNonMadeirables
  }

  public setDanosNonMadeirables (danosNonMadeirables: DanosNonMadeirablesDTO): void {
    this._danosNonMadeirables = danosNonMadeirables
  }
}
